import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from 'src/app/services/auth.service';
import { ExceptionSolutionService } from 'src/app/services/exception-solution.service';
import Swal from 'sweetalert2';
import { ObjectUtils } from '../utils/object-utils';


@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthService, private toastr: ToastrService,
        private exceptionSolutionService: ExceptionSolutionService
    ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {

            let htmlSolution: string = "";
            if (err.status === 401) {
                // auto logout if 401 response returned from api
                // this.authenticationService.invalidateToken().subscribe(async (response) => {
                //     this.authenticationService.removeTokenFromStorage();
                // });
                const error: string = err.error ? (err.error.error_description || err.error.message || (ObjectUtils.isJson(err.error) ? JSON.parse(err.error).message : err.message || err.statusText)) : err;
                if (!request.url.includes("/exception")) {
                    Swal.fire({
                        title: `Error al realizar la operación`,
                        text: error.toLowerCase() == "unauthorized" ? "Usuario o contraseña erroneo" : error,
                        icon: 'error',
                        confirmButtonText: 'Aceptar',
                    });
                }
            }
            else {
                const error = err.error ? (err.error.error_description || err.error.message || (ObjectUtils.isJson(err.error) ? JSON.parse(err.error).message : err.message || err.statusText)) : err;

                if (!request.url.includes("/exception")) {
                    Swal.fire({
                        title: `Error al realizar la operación`,
                        html: `${error} </br></br> ${htmlSolution}`,
                        icon: 'error',
                        confirmButtonText: 'Aceptar',
                        width: "60%"
                    });

                    this.exceptionSolutionService.retriveExceptionSolutionFromMessage(error).subscribe(solution => {
                        if (solution)
                            Swal.update({ html: `${error} </br></br> ${solution}`, });
                    });
                }
            }

            return throwError(err);
        }));
    }
}